/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_Not_InvitedInputs */

const en_signin_sso_x15_not_invited = /** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company account is fine, but this address has no invitation to the workspace yet. Ask your admin to invite you, then sign in again.`)
};

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const ar_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const he_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const ur_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const es_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const fr_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const de_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const pt_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const hi_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/** @type {(inputs: Signin_Sso_X15_Not_InvitedInputs) => LocalizedString} */
const bn_signin_sso_x15_not_invited = en_signin_sso_x15_not_invited;

/**
* | output |
* | --- |
* | "Your company account is fine, but this address has no invitation to the workspace yet. Ask your admin to invite you, then sign in again." |
*
* @param {Signin_Sso_X15_Not_InvitedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_not_invited = /** @type {((inputs?: Signin_Sso_X15_Not_InvitedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_Not_InvitedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_not_invited(inputs)
	if (locale === "he") return he_signin_sso_x15_not_invited(inputs)
	if (locale === "ur") return ur_signin_sso_x15_not_invited(inputs)
	if (locale === "es") return es_signin_sso_x15_not_invited(inputs)
	if (locale === "fr") return fr_signin_sso_x15_not_invited(inputs)
	if (locale === "de") return de_signin_sso_x15_not_invited(inputs)
	if (locale === "pt") return pt_signin_sso_x15_not_invited(inputs)
	if (locale === "hi") return hi_signin_sso_x15_not_invited(inputs)
	if (locale === "bn") return bn_signin_sso_x15_not_invited(inputs)
	return /** @type {LocalizedString} */ ("Your company account is fine, but this address has no invitation to the workspace yet. Ask your admin to invite you, then sign in again.")
});